<li [class.active]="isActive" [class.desktop]="onlyDesktop" class="nav-item">
  <i class="{{ icon }}"></i>
  <h6>{{ name }}</h6>
</li>
